import { watch } from 'vue';
import trackerEngine from '@/trackingEngine';
import { getTaskTrackedSecondsForUser } from '@/utils/taskTrackedTime';

const SYNC_DELAY_MS = 250;
const TRACKED_TIME_SYNC_INTERVAL_MS = 60 * 1000;

function buildPayload(store) {
  const task = store.state.task.activeTrackingTask;
  if (!task) {
    return {
      taskId: null,
      trackedSeconds: 0,
      estimateHours: null,
    };
  }

  return {
    taskId: task.id,
    trackedSeconds: getTaskTrackedSecondsForUser(
      task,
      store.state.user.user.id,
      trackerEngine.getActiveTimeSlot(),
    ),
    estimateHours: task.estimate || null,
  };
}

export function startElectronTrackingProgressSync(store) {
  if (!window.APP_TRON || !window.isMainWindow) {
    return () => {};
  }

  const { ipcRenderer } = window.APP_TRON;
  let updateTimer = null;
  let lastPayloadJson = '';

  const sendUpdate = () => {
    const payload = buildPayload(store);
    const payloadJson = JSON.stringify(payload);
    if (payloadJson === lastPayloadJson) {
      return;
    }

    lastPayloadJson = payloadJson;
    ipcRenderer.send('trackingProgress:update', payload);
  };

  const scheduleUpdate = () => {
    if (updateTimer) {
      clearTimeout(updateTimer);
    }
    updateTimer = setTimeout(sendUpdate, SYNC_DELAY_MS);
  };

  const unwatch = watch(
    () => buildPayload(store),
    scheduleUpdate,
    { deep: true, immediate: true },
  );

  const trackedTimeRefreshTimer = setInterval(scheduleUpdate, TRACKED_TIME_SYNC_INTERVAL_MS);

  return () => {
    unwatch();
    clearInterval(trackedTimeRefreshTimer);
    if (updateTimer) {
      clearTimeout(updateTimer);
    }
  };
}
